export default __webpack_public_path__ + "static/media/vdBg.cc4db308.mp4";